// SVG assets exported from the Figma file's ICON SYSTEM (committed locally —
// the design's remote asset URLs expire). Vite resolves these imports to URLs.
import markPriority from './assets/mark-priority.svg';
import markSupport from './assets/mark-support.svg';
import markGoingWell from './assets/mark-going-well.svg';
import markNothingRecorded from './assets/mark-nothing-recorded.svg';
import placeHome from './assets/place-home.svg';
import placeSchool from './assets/place-school.svg';
import navBook from './assets/nav-book.svg';
import navPerson from './assets/nav-person.svg';
import navBulb from './assets/nav-bulb.svg';
import chevronRightTeal from './assets/chevron-right-teal.svg';
import chevronLeftWhite from './assets/chevron-left-white.svg';
import chevronDownTeal from './assets/chevron-down-teal.svg';
import chevronUpTeal from './assets/chevron-up-teal.svg';
import iconDownloadWhite from './assets/icon-download-white.svg';
import iconDownloadSmallWhite from './assets/icon-download-small-white.svg';
import iconArrowRightWhite from './assets/icon-arrow-right-white.svg';
import iconCloseWhite from './assets/icon-close-white.svg';
import iconDoneSnackbar from './assets/icon-done-snackbar.svg';
import iconClockWhite from './assets/icon-clock-white.svg';
import iconAlertWhite from './assets/icon-alert-white.svg';
import iconNoConnection from './assets/icon-no-connection.svg';
import radioRing from './assets/radio-ring.svg';
import radioRingSelected from './assets/radio-ring-selected.svg';
import tickSelected from './assets/tick-selected.svg';
import iconInfoTeal from './assets/icon-info-teal.svg';
import catEnvironmental from './assets/cat-environmental.svg';
import catScaffolding from './assets/cat-scaffolding.svg';
import catSkillBuilding from './assets/cat-skill-building.svg';

export const MARKS = {
  priority: markPriority,
  support: markSupport,
  well: markGoingWell,
  none: markNothingRecorded,
};

export const PLACES = { home: placeHome, school: placeSchool };

export const NAV_ICONS = { guide: navBook, profile: navPerson, help: navBulb };

export const CAT_ICONS = {
  Environmental: catEnvironmental,
  Scaffolding: catScaffolding,
  'Skill-building': catSkillBuilding,
};

export {
  chevronRightTeal,
  chevronLeftWhite,
  chevronDownTeal,
  chevronUpTeal,
  iconDownloadWhite,
  iconDownloadSmallWhite,
  iconArrowRightWhite,
  iconCloseWhite,
  iconDoneSnackbar,
  iconClockWhite,
  iconAlertWhite,
  iconNoConnection,
  radioRing,
  radioRingSelected,
  tickSelected,
  iconInfoTeal,
};
